import { ModelRoutes, ModelApiService } from "services/strapi"
import { ITaskStep } from "features/task-steps"
class TaskStepApiSingleton extends ModelApiService<ITaskStep> {}

export const taskStepApi = new TaskStepApiSingleton(ModelRoutes.TaskSteps)
